var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('clearanceApproval.changeExpiration'),
      "subtitle": _vm.$t('clearanceApproval.untilWhenHint'),
      "loading": _vm.isUpdateLoading,
      "rightLoading": _vm.isUpdateLoading,
      "hideLeft": false,
      "rightText": _vm.$t('confirm'),
      "leftText": _vm.$t('close')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "close": _vm.close,
      "leftClick": _vm.close,
      "rightClick": _vm.confirm
    }
  }, [_c('v-date-picker', {
    attrs: {
      "outlined": "",
      "full-width": ""
    },
    model: {
      value: _vm.valueCopy.dueFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "dueFormable", $$v);
      },
      expression: "valueCopy.dueFormable"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }